import { useEffect, useState, createContext, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";

const RoleCtx = createContext("coach");
export const useP11Role = () => useContext(RoleCtx);

// Guard voor /project11/admin — bestaande JOH. admin-credentials, daarna P11-rol.
export default function P11AdminGuard({ children }) {
  const nav = useNavigate();
  const { pathname } = useLocation(); // stabiel per render — window.location racet onder StrictMode
  const [state, setState] = useState("loading");
  const [role, setRole] = useState("coach");
  useEffect(() => {
    if (!localStorage.getItem("joh_admin_token")) {
      nav(`/admin/login?next=${encodeURIComponent(pathname)}`, { replace: true });
      return;
    }
    let cancelled = false;
    api.get("/project11/admin/me")
      .then(({ data }) => { if (!cancelled) { setRole(data.p11_role); setState("ok"); } })
      .catch((err) => {
        if (cancelled) return;
        const s = err?.response?.status;
        if (s === 401) {
          localStorage.removeItem("joh_admin_token");
          nav(`/admin/login?next=${encodeURIComponent(pathname)}`, { replace: true });
        } else setState("denied");
      });
    return () => { cancelled = true; };
  }, [nav, pathname]);
  if (state === "loading") return <div className="p11-root min-h-screen flex items-center justify-center"><span className="p11-label" data-testid="p11-admin-loading">PROJECT 11* / ADMIN …</span></div>;
  if (state === "denied") return <div className="p11-root min-h-screen flex items-center justify-center"><span className="p11-label" data-testid="p11-admin-denied">GEEN TOEGANG — ADMIN VEREIST</span></div>;
  return <RoleCtx.Provider value={role}>{children}</RoleCtx.Provider>;
}
